import styled from 'styled-components'
import { sc } from 'utils'
import { getChevron } from 'icons'

type Props = {
  secondary?: boolean
  small?: boolean
}

export default styled.select<Props>`
  padding: ${sc('small', '10px 34px 10px 12px', '15px 34px 15px 16px')};

  background-color: ${sc('secondary', 'transparent', 'white')};
  background-image: url(${sc('secondary', getChevron('white'), getChevron())});
  background-repeat: no-repeat;
  background-position: calc(100% - 9px) calc(50% + 1px);

  border: 1px solid var(--light-gray);
  border-radius: 4px;

  color: ${sc('secondary', 'white', 'var(--gray)')};
  font: var(--400-13);

  cursor: pointer;
  appearance: none;
  user-select: none;
  transition: background-color 0.2s;

  :hover:enabled:not(:focus-visible) {
    background-color: ${sc('secondary', 'rgba(255, 255, 255, 0.1)', 'var(--green_0-1)')};
  }

  :focus-visible {
    outline: 2px solid var(--green_0-5);
  }

  :disabled {
    background-color: var(--light-gray);
    background-image: url(${getChevron('white')});
    color: white;
    opacity: unset;
    cursor: not-allowed;
  }
`
